import React from 'react';
import { connect } from 'react-redux';

import { Input } from 'reactstrap';
import MandatoryStar from 'cyder/forms/MandatoryStar';

import InputFieldWithValidation from 'reactstrap-input';

export const PaymentInput = ({ label, description, placeholder, value, onChange, inputStyle, valueKey = '', validationObj = {} }) => (
    <div className="form-group">
        <label className="field-header">
            {label} <MandatoryStar />
        </label>
        <InputFieldWithValidation
            type="text"
            className="form-control"
            colWidth=" m-0"
            inputStyle={inputStyle}
            placeholder={placeholder}
            labelStyle={{ display: 'none' }}
            valueKey={valueKey} // id
            value={value}
            validationObj={validationObj} // Entire validation objs (object key must match the value key given)
            handleChange={onChange}
            saveButtonPressed={true}
        />
        {description && <small className="form-text text-muted">{description}</small>}
    </div>
);

class CashPayment extends React.Component {
    render() {
        return (
            <div className="row">
                <div className="col-12 col-lg-12">
                    <PaymentInput
                        label="Payment Amount"
                        description="Please enter amount of payment"
                        placeholder=""
                        inputStyle={{ width: '100px' }}
                        onChange={e => this.props.onTextChanged(e.target.value, 'amountReceived')}
                        value={this.props.paymentInfo.amountReceived}
                    />
                    <PaymentInput
                        label="Date of Payment"
                        description="Please select date of payment"
                        placeholder=""
                        onChange={e => this.props.onTextChanged(e.target.value, 'datePaymentReceived')}
                        value={this.props.paymentInfo.datePaymentReceived}
                    />
                    <PaymentInput
                        label="Remarks"
                        description="Please enter remarks"
                        placeholder=""
                        inputStyle={{ width: '450px' }}
                        onChange={e => this.props.onTextChanged(e.target.value, 'remarks')}
                        value={this.props.paymentInfo.remarks}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ownProps,
    };
};
const mapDispatchToProps = dispatch => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CashPayment);
